// Logo Alis Fiyati sayfasi. Swagger'da GET yok => gonderim odakli (bkz. Satis Fiyati).
import { ResourceListPage, ResourceConfig, FieldSpec } from '../components/ResourceListPage';
import { ItemPurchasePrice, emptyPurchasePrice, LogoResult } from '../types';
import { savePurchasePrice } from '../api/item-prices';

let seq = 0;
const store: Array<ItemPurchasePrice & { _key: number }> = [];

const columns = [
  { dataField: 'itemCode', caption: 'Malzeme Kodu', width: 150 },
  { dataField: 'clientCode', caption: 'Tedarikci', width: 130 },
  { dataField: 'price', caption: 'Fiyat', width: 110, alignment: 'right' as const, dataType: 'number' as const },
  { dataField: 'unitCode', caption: 'Birim', width: 90 },
  { dataField: 'vatIncl', caption: 'KDV Dahil', width: 100, alignment: 'center' as const,
    cellRender: (d: any) => (d.data.vatIncl ? 'Evet' : 'Hayir') },
  { dataField: 'dateBegin', caption: 'Baslangic', width: 120 },
  { dataField: 'dateEnd', caption: 'Bitis', width: 120 },
  { dataField: 'divCodes', caption: 'Isyeri Kodlari', width: 'auto' },
];

const fields: FieldSpec[] = [
  { field: 'itemCode', label: 'Malzeme Kodu', required: true, tab: 'Genel' },
  { field: 'clientCode', label: 'Tedarikci Kodu', tab: 'Genel' },
  { field: 'price', label: 'Fiyat', editor: 'number', required: true, tab: 'Genel' },
  { field: 'currency', label: 'Doviz', editor: 'number', tab: 'Genel' },
  { field: 'vatIncl', label: 'KDV Dahil', editor: 'check', tab: 'Genel' },
  { field: 'unitCode', label: 'Birim', tab: 'Genel' },
  { field: 'priority', label: 'Oncelik', editor: 'number', tab: 'Genel' },
  { field: 'dateBegin', label: 'Baslangic Tarihi', editor: 'date', tab: 'Genel' },
  { field: 'dateEnd', label: 'Bitis Tarihi', editor: 'date', tab: 'Genel' },
  { field: 'divCodes', label: 'Isyeri Kodlari', colSpan: 2, tab: 'Genel' },

  { field: 'arpTradingGroup', label: 'Cari Ticari Grup', tab: 'Cari' },
  { field: 'arpAuthCode', label: 'Cari Yetki Kodu', tab: 'Cari' },
  { field: 'arpSpecode1', label: 'Cari Ozel Kod 1', tab: 'Cari' },
  { field: 'arpSpecode2', label: 'Cari Ozel Kod 2', tab: 'Cari' },
  { field: 'arpSpecode3', label: 'Cari Ozel Kod 3', tab: 'Cari' },
  { field: 'arpSpecode4', label: 'Cari Ozel Kod 4', tab: 'Cari' },
  { field: 'arpSpecode5', label: 'Cari Ozel Kod 5', tab: 'Cari' },
];

const config: ResourceConfig<ItemPurchasePrice & { _key: number }> = {
  keyExpr: '_key',
  columns,
  fields,
  load: async () => ({ ok: true, data: [...store] } as LogoResult<any>),
  save: async (p) => {
    const res = await savePurchasePrice(p);
    if (res.ok) store.push({ ...p, _key: ++seq });
    return res;
  },
  newItem: () => ({ ...emptyPurchasePrice(), _key: 0 }),
  headerLabel: (p) => (p.itemCode ? `${p.itemCode} — ${p.price}` : 'Yeni Alis Fiyati'),
};

export default function LogoPurchasePricesPage() {
  return <ResourceListPage config={config} />;
}
